var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiddle2Bg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 463,
    height: 391,
    viewBox: "0 0 463 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.606 301.449C445.246 339.117 410.9 369.298 371.261 384.524C334.732 398.557 291.964 381.637 251.298 380.7C219.631 379.97 189.665 381.923 157.974 379.608C116.171 376.554 64.6357 393.386 34.9475 364.895C5.41473 336.554 32.8479 291.149 26.5733 253.51C21.0725 220.512 -2.20829 190.217 0.359897 157.417C3.19909 121.156 11.2138 80.916 41.8029 59.0035C72.3218 37.1413 119.844 53.7736 157.969 44.514C200.12 34.2762 233.4 -8.87411 276.954 1.89033C319.842 12.4901 333.908 62.966 362.186 94.9861C388.279 124.532 421.266 148.808 437.257 183.407C454.77 221.302 469.99 263.711 457.606 301.449Z",
    fill: "#F2EFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddle2Bg);
export default __webpack_public_path__ + "static/media/middle2_bg.0e15ff33e7f5aea04d05172d7cdd34d2.svg";
export { ForwardRef as ReactComponent };